import React from 'react'

import './ChangeRecurrenceAliadaConfirm.scss'
import ChangeAliadaConfirmBase from 'components/ChangeAliadaConfirmBase'
import RecurrenceModificationPenalty from 'components/RecurrenceModificationPenalty'

class ChangeRecurrenceAliadaConfirm extends ChangeAliadaConfirmBase {
  constructor (props) {
    super(props)

    this.navBarLabel = 'Modificar Recurrencia'
  }

  renderPenalty (props) {
    const {
      bookingId,
      bookingModifications,
      onPenaltyFetched
    } = props
    return (
      <RecurrenceModificationPenalty
        recurrenceId={bookingId}
        recurrenceModifications={bookingModifications}
        onPenaltyFetched={onPenaltyFetched}
      />
    )
  }
}

ChangeRecurrenceAliadaConfirm.displayName = 'ChangeRecurrenceAliadaConfirm'

export default ChangeRecurrenceAliadaConfirm



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/ChangeRecurrenceAliadaConfirm/ChangeRecurrenceAliadaConfirm.js